//base url
// export const baseURL = "http://d4a981714947.ngrok.io";
export const baseURL = "https://apps.ng.kpmg.com/NigeriaEthicsAPI";

//common headers
export const commonHeaders ={'APIKey': '4d53bKce03ec34cP0a91118M2d4c228eGe6c'};
//enpoints 
export const endpoints = {
    submitIncident:"api/reportIncident",
    getFeedback:"api/getFeedback",
    getMetaData:"api/getAll"
}

